import { render, staticRenderFns } from "./modify-mail-template.vue?vue&type=template&id=c605057c&scoped=true"
import script from "./modify-mail-template.vue?vue&type=script&lang=ts"
export * from "./modify-mail-template.vue?vue&type=script&lang=ts"
import style0 from "./modify-mail-template.vue?vue&type=style&index=0&id=c605057c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c605057c",
  null
  
)

export default component.exports